/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchTimecardEditChangeProposals} from '../api'

export const useMutationSearchTimecardEditChangeProposals = createReactQueryMutationHook('searchTimecardEditChangeProposals', searchTimecardEditChangeProposals)
